import {
  ALLOWED_ORDER,
  ALLOWED_SORT_KEY,
  PRODUCT_LIST_LIMIT,
  PRODUCT_MORE_LIMIT
} from './constants/page';

import { PRODUCTS_COLLECTION } from 'Queries/PRODUCTS_COLLECTION';
import isEmpty from 'utils/isEmpty';
import qs from 'qs';

export const productsQuery = (queryParams, after = null) => {
  let productQuery = queryUtil.baseQuery(queryParams, after);
  const { list: type = '', slug, q:keyword = '' } = queryParams

  productQuery.query = PRODUCTS_COLLECTION;

  if(!isEmpty(keyword)) {
    productQuery.variables.keyword = keyword
  }


  switch (type) {
    case 'category':
      productQuery.variables = {
        ...productQuery.variables,
        categoryIn: [slug],
        withCategory: true,
        withSlug: slug
      };
      break;
    case 'collection':
      productQuery.variables = {
        ...productQuery.variables,
        collectionIn: [slug],
        withCollection: true,
        withSlug: slug
      };
      break;
    case 'brands':
      productQuery.variables = {
        ...productQuery.variables,
        brandIn: [slug],
        withBrand: true,
        withSlug: slug
      };
      break;
    case 'perfumenotes':
      productQuery.variables = {
        ...productQuery.variables,
        perfumeNoteIn: [slug],
        withPerfumeNote: true,
        withSlug: slug
      };
      break;
    case 'tag':
      productQuery.variables = {
        ...productQuery.variables,
        tagIn: [slug],
        withTag: true,
        withSlug: slug
      };
      break;
    default:
      break;
  }

  return productQuery;
};

export const productsMoreQuery = (queryParams, after = null) => {
  let productQuery = queryUtil.baseQuery(queryParams, after);
  const { list: type = '', slug, q:keyword = '' } = queryParams

  productQuery.query = PRODUCTS_COLLECTION;
  productQuery.variables = {
    ...productQuery.variables,
    first: PRODUCT_MORE_LIMIT,
    keyword: keyword
  }

  switch (type) {
    case 'category':
      productQuery.variables = {
        ...productQuery.variables,
        categoryIn: [slug],
      };
      break;
    case 'collection':
      productQuery.variables = {
        ...productQuery.variables,
        collectionIn: [slug],
      };
      break;
    case 'brands':
      productQuery.variables = {
        ...productQuery.variables,
        brandIn: [slug],
      };
      break;
    case 'perfumenotes':
      productQuery.variables = {
        ...productQuery.variables,
        perfumeNoteIn: [slug],
      };
      break;
    case 'tag':
      productQuery.variables = {
        ...productQuery.variables,
        tagIn: [slug],
      };
      break;
    default:
      break;
  }

  return productQuery;
};

const queryUtil = {
  baseQuery: (queryParams, after) => {
    let productQuery = {
      query: '',
      variables: {
        first: PRODUCT_LIST_LIMIT,
        sort: queryUtil.getSortQuery(queryParams),
        after: after
      },
      // fetchPolicy: 'network',
      fetchPolicy: "no-cache" ,
      ssrMode: true,
    };

    if (queryUtil.getQueryByKey(queryParams, 'onSale') === 'true') {
      productQuery.variables['onSale'] = true;
    }

    return productQuery;
  },

  getQueryByKey: (query, key) => qs.parse(query)[key],
  getSortQuery: (query) => {
    const sortQueryObj = queryUtil.getQueryByKey(query, 'sort');
    if (typeof sortQueryObj !== 'object') {
      return null;
    }

    let acceptedObject = [];

    Object.entries(sortQueryObj).forEach(([k, v]) => {
      const keyUpper = k.toUpperCase();
      const valUpper = v.toUpperCase();
      const val =
        !isEmpty(valUpper) && ALLOWED_ORDER.indexOf(valUpper) > -1
          ? valUpper
          : 'ASC';
      if (ALLOWED_SORT_KEY.indexOf(keyUpper) > -1) {
        acceptedObject.push({ field: keyUpper, order: val });
      }
    });

    return acceptedObject.length > 0 ? acceptedObject : null;
  },
  getFilterQuery: (query) => { }
};
